export default "__VITE_ASSET__CVISRkI3__"